export const
    cmdSave = 'save-page',
    gridCompId = 'css-grid',
    gridChildId = 'grid-cell';